export default "__VITE_ASSET__BVKaBdFl__"